import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      alignSelf: 'stretch',
    },
    errorPanel: {
      marginTop: '5px',
      marginBottom: '15px',
      alignSelf: 'stretch',

      '& p': {
        margin: 0,
      },
    },
    field: {
      margin: '0',

      '& + &': {
        marginTop: theme.spacing(2),
      },
    },
    button: {
      marginTop: theme.spacing(4),
    },
  }),
  { name: 'SSOLogin' }
);
